import styled from 'styled-components'
import ButtonComponent from '../../button'

export const Button = styled(ButtonComponent)`
    border-radius: inherit;
    min-width: auto;
    width: 100%;
`

export const Options = styled.div`
    border-radius: inherit;
    display: flex;
    flex-direction: row;
`
